import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SPORTS_LIST = [
  {
    id: 'action-sports',
    title: 'ACTION SPORTS',
    description:
      'Stream Action Sports live streams for surfing, mountain bike and summer / winter Extreme Sports free. Watch the best action from the World Surf League, snowboarding, BMX, kart, skateboards, and more free.',
    buttonText: 'STREAM ACTION SPORTS FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-ActionSports.jpg',
  },
  {
    id: 'basketball',
    title: 'BASKETBALL',
    description:
      'Watch Basketball including classic NBA/NCAA games, euro and exotic streams 24/7 immediately. Watch matches, highlights, interviews, post shows, re-plays and more.',
    buttonText: 'STREAM BASKETBALL FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-basketball.jpg',
  },
  {
    id: 'billiards',
    title: 'BILLIARDS',
    description:
      'Stream 8-Ball, Nine-Ball, Snooker, Pool and other cue-sport tour and club sports. Try Americas 9ball, Trick-Shot-Tournaments, Three-Cushion Billiards, Snooker events, pool-hall 8ball, 9ball and more.',
    buttonText: 'STREAM BILLIARDS FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-billiards.jpg',
  },
  {
    id: 'extreme-sports',
    title: 'EXTREME SPORTS',
    description:
      "Stream surfing, skateboarding, snowboarding, wakeboarding, motocross, BMX, mountain biking. If it's extreme sporting sports action - we have it, packed and ready to watch 24/7, for free.",
    buttonText: 'STREAM EXTREME SPORTS FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-extreme.jpg',
  },
  {
    id: 'american-football',
    title: 'AMERICAN FOOTBALL',
    description:
      'Stream collegiate and high-school American Football live, featuring top national teams. Plus, watch interviews, archived games, documentaries and more.',
    buttonText: 'STREAM AMERICAN FOOTBALL FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-american-football.jpg',
  },
  {
    id: 'horseback-riding',
    title: 'HORSEBACK RIDING',
    description:
      'Stream equestrian, Thoroughbred and harness racing, featuring top international sports and harness or equestrian shows to make the most of your horse-back riding life.',
    buttonText: 'STREAM HORSEBACK RIDING FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-horseback-riding.jpg',
  },
  {
    id: 'baseball',
    title: 'BASEBALL',
    description:
      'Watch high school, international, and minor-league baseball. See championship games and highlights. Access the sports you love, anywhere in the world of Baseball.',
    buttonText: 'STREAM BASEBALL FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-baseball.jpg',
  },
  {
    id: 'lacrosse',
    title: 'LACROSSE',
    description:
      'Stream high-school, collegiate, and professional lacrosse games, documentaries, and highlights. FreeLiveSports TV offers you the best out of free and live lacrosse content.',
    buttonText: 'STREAM LACROSSE FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-lacrosse.jpg',
  },
  {
    id: 'mma',
    title: 'MMA (MIXED MARTIAL ARTS)',
    description:
      'Stream Boxing, Kickboxing, Muay Thai and MMA in live tournaments, past matches, highlights and news series.',
    buttonText: 'STREAM MMA FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-MMA.jpg',
  },
  {
    id: 'motorsport',
    title: 'MOTORSPORT',
    description:
      'Stream all kinds of motorsporting content; Motorsport, Formula Drift, Drag Racing, Off Road Racing, Auto Racing, Hydroplane, Water-Biking Racing... You name it! We have it.',
    buttonText: 'STREAM MOTORSPORT FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-Motorsports.jpg',
  },
  {
    id: 'poker',
    title: 'POKER',
    description:
      'Stream high-roller games free. High stakes live games, and World Poker Championship matches 24/7 on demand.',
    buttonText: 'STREAM POKER FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/Genere-Poker.jpg',
  },
  {
    id: 'specialist',
    title: 'SPECIALIST',
    description:
      'Stream everything from yoga and chess through to airborne parachute, bull-riding, fishing and a host of other sports.',
    buttonText: 'STREAM SPORTS FREE ▶',
    image:
      'https://gizmeon.mdc.akamaized.net/files/web/images/fls/sports/genere-othersports-v3.jpg',
  },
];

const OurSports = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleStreamClick = (sport) => {
    if (sport.id === 'action-sports') {
      navigate('/action-extreme-sports');
    } else if (sport.id === 'basketball') {
      navigate('/basketball');
    } else if (sport.id === 'billiards') {
      navigate('/billiards');
    } else if (sport.id === 'extreme-sports') {
      navigate('/extreme-sports');
    } else if (sport.id === 'american-football') {
      navigate('/football');
    } else if (sport.id === 'horseback-riding') {
      navigate('/horseback-riding');
    } else if (sport.id === 'baseball') {
      navigate('/baseball');
    } else if (sport.id === 'lacrosse') {
      navigate('/lacrosse');
    } else if (sport.id === 'mma') {
      navigate('/mixed-martial-arts');
    } else if (sport.id === 'motorsport') {
      navigate('/motorsport');
    } else if (sport.id === 'poker') {
      navigate('/poker');
    } else if (sport.id === 'specialist') {
      navigate('/other-sports');
    } else {
      navigate('/live-channels', { state: { category: sport.title, genreId: sport.id } });
    }
  };

  return (
    <div className="ourSportsContainer">
      <div className="ourSportsHeader">
        <h1 className="mainTitle">OUR SPORTS</h1>
        <p className="subTitle">
          Check out the full list of sports currently available to watch on FreeLiveSports.
        </p>
      </div>

      <div className="sportsListWrapper">
        {SPORTS_LIST.map((sport) => (
          <div
            key={sport.id}
            className="sportBannerRow"
            style={{
              backgroundImage: `url(${sport.image})`,
            }}
          >
            <div className="sportRowContent">
              <h2 className="sportTitle">{sport.title}</h2>
              <p className="sportDescription">{sport.description}</p>
              <button
                className="streamButton"
                onClick={() => handleStreamClick(sport)}
                aria-label={sport.buttonText}
              >
                {sport.buttonText}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurSports;
